const apiKeys = {
  captcha: '6LeW6_0gAAAAAAPZYUooX9lRjrsbIME-gVIsHPVB',
};

export default apiKeys;
